import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { Typography, Button } from '@qlub-dev/qlub-kit';
import { useTranslation } from '@clubpay/customer-common-module/src/hook/translations';
import { Drawer, IconButton } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';

import styles from './index.module.scss';

interface IProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const QSRBasketResetModal = ({ open, onClose, onConfirm }: IProps) => {
    const { t } = useTranslation('common');

    return (
        <Drawer
            variant="temporary"
            anchor="bottom"
            disablePortal
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    maxWidth: '552px',
                    margin: '0 auto',
                    background: '#fff',
                    borderRadius: '30px 30px 0 0',
                    padding: '24px',
                },
            }}
        >
            <IconButton onClick={onClose} className={styles.closeIcon}>
                <CloseRounded />
            </IconButton>
            <div className={styles.container}>
                <div className={styles.header}>{t('Want to change order type?')}</div>
                <div className={styles.body}>
                    <ErrorIcon />
                    <Typography className={styles.title}>
                        {t('Changing your order type will remove all items from your cart')}
                    </Typography>
                    <Typography className={styles.desc}>
                        {t(
                            'You will need to start your order again from the beginning. Are you sure you want to continue?',
                        )}
                    </Typography>
                    <div className={styles.buttonGroup}>
                        <Button fullWidth className={styles.cancelBtn} onClick={onClose}>
                            {t('Cancel')}
                        </Button>
                        <Button fullWidth className={styles.confirmBtn} onClick={onConfirm}>
                            {t('Confirm')}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default QSRBasketResetModal;
